module.exports = __webpack_public_path__ + "img/icon_task.06d6b460.png";